var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-container',[_c('ui-button',{nativeOn:{"click":function($event){return _vm.openStudio()}}},[_vm._v("Test studio")]),(_vm.imageUrl)?_c('img',{style:({maxWidth: '100%', margin: '20px 0'}),attrs:{"src":_vm.imageUrl}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }